import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false,
})
export class PageNotFoundComponent {
    public title = 'The page could not be found';
    private _location = inject(Location);

    public goBack(): void {
        this._location.back();
    }
}
